import React from 'react'
import './styles.scss';

export const AppFooter = () => (
  <div className="layout-footer">
    <img src="/assets/layout/images/logo-whitse.png" alt="" width="50" />
{/*     <span className="footer-text" style={{ marginRight: '5px' }}>
      {process.env.REACT_APP_NAME}
    </span> */}

  </div>
)
